import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';

function PchLoading() {
	return (
		<Typography variant='h5'>
			Loading... <CircularProgress />
		</Typography>
	);
}

export default PchLoading;
